import {Service, service, inject} from "./di";
import {Flyer} from "../definitions/FlyerDefinitions";

@service
export default class FlyersSortService extends Service {
	filter(flyers: Flyer[], category: string, sort: string): {
		premiumFlyers: Flyer[];
		normalFlyers: Flyer[];
	} {
		if (sort === "latest") {
			const normalFlyers = flyers
				.filter((flyer) => flyer.categories.indexOf(category) >= 0)
				.sort((lhs, rhs) => lhs.availableFrom > rhs.availableFrom ? -1 : 1);
			return { premiumFlyers: [], normalFlyers };
		} else if (sort === "alphabetical") {
			const normalFlyers = flyers
				.filter((flyer) => flyer.categories.indexOf(category) >= 0)
				.sort((lhs, rhs) => {
					const rhsTitle = `${rhs.merchant} ${rhs.name}`;
					const lhsTitle = `${lhs.merchant} ${lhs.name}`;
					return lhsTitle.localeCompare(rhsTitle, undefined, {
						sensitivity: "base"
					});
			});
			return { premiumFlyers: [], normalFlyers };
		} else {
			const premiumFlyers = flyers.filter((flyer) => flyer.premium && flyer.categories.indexOf(category) >= 0);
			const normalFlyers = flyers.filter((flyer) => !flyer.premium && flyer.categories.indexOf(category) >= 0);
			return { premiumFlyers, normalFlyers };
		}
	}

}
